import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
} from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import {
  common_groupstructure_GETROW,
  common_brandgroup_GETROW,
  common_brandbasedgroup_GETROW,
  common_LocationSearch_GETROW,
  WMSInbound_grnAttributes_GETROW,
} from "../../Server/ApiV2";

export const sWebStockReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebStockReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];
export const sWebPartyReportArr = [
  { UId: "All", Name1: "All" },
  { UId: "VENDOR_INV", Name1: "From Vendor" },
  { UId: "TRANSFER_RETURN", Name1: "Transfer Return" },
  { UId: "SALES_RETURN", Name1: "Sales Return" },
];

export const HeadObjectInit = {
  sFromDate: new Date(),
  sToDate: new Date(),
  sboundType: sWebPartyReportArr[0].UId,
  sReportType: "INBOUND",
  sLocation: "Is",
  sMainGroup: "All",
  sSubGroup: "All",
  sCategory: "All",
  sMainSupplier: "All",
  sBrand: "All",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sMainGroupArr: [],
  sMainGroupPrnt: "",
  sMainGroupCode: "",
  sMainGroupName: "",
  sSubGroupArr: [],
  sSubGroupPrnt: "",
  sSubGroupCode: "",
  sSubGroupName: "",
  sCategoryArr: [],
  sCategoryPrnt: "",
  sCategoryCode: "",
  sCategoryName: "",
  sMainSupplierArr: [],
  sMainSupplierPrnt: "",
  sMainSupplierCode: "",
  sMainSupplierName: "",
  sBrandArr: [],
  sBrandPrnt: "",
  sBrandCode: "",
  sBrandName: "",
  sBrandSearchValue: "",
  sBrandCategoryArr: [],
  sBrandCategoryPrnt: "",
  sBrandCategoryCode: "",
  sBrandCategoryName: "",
};

export const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const fWmsStockRepotBrandArr = async (
  xGroupStructureObj,
  setGroupData
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotBrand = async (setGroupData) => {
  const CurrentMaingroupArr = await common_brandgroup_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotMainSupplier = async (
  xPartyData,
  setGroupData
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xPartyData);
  const CurrentMaingroupArr = await WMSInbound_grnAttributes_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet?.PartyLoading);
  }
};

export const fWmsStockRepotHeadObj = async (
  xGroupStructureObj,
  setHeadObject,
  xkey
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setHeadObject((obj) => ({
      ...obj,
      xkey: CurrentMaingroupArr?.data?.ResultSet,
    }));
  }
};

export const GetLocation = async (setLocation) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
  var vLocobj = {
    v_AnyData: "",
    v_Cd: "",
    v_Name: "",
    v_Distri: "Y",
    v_UserCd: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
  const vLocation = await common_LocationSearch_GETROW(FinalObj);
  if (vLocation?.status === 200) {
    setLocation(vLocation?.data?.ResultSet);
  }
};

export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sFromDate === "" ||
    HeadObject.sFromDate === null ||
    HeadObject.sFromDate === undefined ||
    HeadObject.sFromDate === "Invalid Date" ||
    HeadObject.sToDate === "" ||
    HeadObject.sToDate === null ||
    HeadObject.sToDate === undefined ||
    HeadObject.sToDate === "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sboundType === "" ||
    HeadObject.sboundType === null ||
    HeadObject.sboundType === undefined
  ) {
    fAlertToast("FAILED", "Bound Type should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sReportType === "" ||
    HeadObject.sReportType === null ||
    HeadObject.sReportType === undefined
  ) {
    fAlertToast("FAILED", "Report Type should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sMainGroup.toUpperCase() === "IS" &&
    HeadObject.sMainGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "MainGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sSubGroup.toUpperCase() === "IS" &&
    HeadObject.sSubGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "SubGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sCategory.toUpperCase() === "IS" &&
    HeadObject.sCategoryPrnt === ""
  ) {
    fAlertToast("FAILED", "Category should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sMainSupplier.toUpperCase() === "IS" &&
    HeadObject.sMainSupplierPrnt === ""
  ) {
    fAlertToast("FAILED", "Party should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sBrand.toUpperCase() === "IS" &&
    HeadObject?.sBrandArr.map((x) => x.UID).join(",") === ""
  ) {
    fAlertToast("FAILED", "Brand should not be empty");
    iRes = false;
    return iRes;
  }
  // if (
  //   HeadObject.sBrand.toUpperCase() === "IS" &&
  //   HeadObject.sBrandCategoryPrnt === ""
  // ) {
  //   fAlertToast("FAILED", "BrandCategory should not be empty");
  //   iRes = false;
  //   return iRes;
  // }

  return iRes;
};
